import React from "react";
import { useHistory } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED } from "graphql/query/language-gql";
import { LANGUAGE_DELETE } from "graphql/mutation/language-gql";
import { errorNotification, successNotification } from "components/request-result";
import { EntityRemoveButton, Localize } from "components/service";
import Icons from "components/icons";
import LanguageConst from "../language-const";


const basePath = LanguageConst.basePath;

const LanguageActionField = ({ language }) => {

    const history = useHistory();

    const [ languageDeleteRequest, { loading } ] = useMutation(LANGUAGE_DELETE, {
        refetchQueries: [ GET_LANGUAGES, GET_LANGUAGES_ALL, GET_LANGUAGES_PAGINATED ],
        update(cache, { data }) {
            const {
                languageDelete: {
                    label,
                    message
                }
            } = data;

            successNotification({
                title: label,
                description: message
            });

            history.push(`${ basePath }`);
        },
        onError(error) {
            errorNotification(error);
        }
    });

    const menu = (
        <Menu
            items={ [
                {
                    label: <Localize>MENUS_DROP.Label_Edit</Localize>,
                    key: '1',
                    icon: <Icons.Edit />,
                    onClick: () => history.push(`${ basePath }/${ language.id }`)
                },
                {
                    key: '2',
                    icon: <EntityRemoveButton
                        modalButton={
                            <span style={ { display: 'flex', alignItems: 'center' } }>
                                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
                            </span>
                        }
                        nameEntity={ Localize({ children: "ENTITY.Modal_Title_Language" }).props.children }
                        dataNameEntity={ language.label || language.slug }
                        loading={ loading }
                        deleteMutation={ languageDeleteRequest }
                        variables={ {
                            id: language.id,
                        } }
                    />,
                },
            ] }
        />
    );

    return (
        <Dropdown
            overlay={ menu }
            overlayClassName="drop-more-menu"
            placement="bottomRight"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default LanguageActionField;
